import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Image = styled.img`
  opacity: ${({ $loaded }) => ($loaded ? 1 : 0)};
  transition: opacity 0.7s ease, transform 0.9s cubic-bezier(0.22, 1, 0.36, 1);
`;

// An <img> that fades in once it has loaded instead of popping in.
const FadeImage = (props) => {
  const ref = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (ref.current?.complete) setLoaded(true);
  }, []);

  return (
    <Image
      ref={ref}
      $loaded={loaded}
      onLoad={() => setLoaded(true)}
      onError={() => setLoaded(true)}
      {...props}
    />
  );
};

export default FadeImage;
